import EditorFrame from "@/components/editors/EditorFrame";
import { FormCompanyItems } from "@/components/editors/template-blocks/service-form/form-items/FormCompanyItems";
import { FormItemsProps } from "@/components/editors/template-blocks/service-form/form-items/FormRowsRenderer";
import { FormServiceTemplate } from "@/states/page-editor/template-parts/service-form";
import { useHandleFieldValueChange } from "@/states/service-form/operations";
import {
  useCannotOrderReasons,
  useServiceFormUiState,
  useServiceInfo,
} from "@/states/service-form/selectors";
import {
  FieldValueChangeHandler,
  ServiceFormUiState,
} from "@/states/service-form/types";

interface ServiceFormTemplateProps {
  part?: FormServiceTemplate;
  formPath?: string;
}

export const ServiceFormTemplate = (props: ServiceFormTemplateProps) => {
  const { part, formPath } = props;

  const serviceFormUiState = useServiceFormUiState();
  const onFieldValueChange = useHandleFieldValueChange();
  const cannotOrderReasons = useCannotOrderReasons();
  const service = useServiceInfo();
  const switchFormItem = (
    serviceFormState: ServiceFormUiState,
    onFieldValueChange: FieldValueChangeHandler,
  ) => {
    if (serviceFormState.status === "Loaded") {
      const formItemsProps: FormItemsProps = {
        formData: serviceFormState.formData.customer,
        inputs: serviceFormState.inputs.customer,
        errors: serviceFormState.errors,
        onFieldValueChange: onFieldValueChange,
        options: serviceFormState.options,
        isBorder: false,
      };

      switch (part?.type) {
        case "menu.form":
        case "menu.eventSeminar":
        case "menu.subscription":
        case "menu.other":
        case "form2.type1":
          return (
            <div id="service-form-template">
              <FormCompanyItems props={formItemsProps} />
            </div>
          );
          ``;
        default:
          return <></>;
      }
    }
  };

  // Calendar bookings place the form after slot selection (/form/{uuid}/select), so only
  // other types may show it on the LP. Keying off formPath alone let it appear whenever
  // the LP cleared formPath (redmine #1149).
  if (formPath || service?.type === "calendar") {
    return <></>;
  }

  return (
    <div
      className={`mx-[-16px] px-0 md:mx-[calc((-100vw+920px)/2)] md:px-[calc((100vw-920px)/2)]`}
      style={part?.bgCssProperties}
    >
      <EditorFrame noBorder isNoPadding>
        {cannotOrderReasons.length > 0 && (
          <div className="form-error-text my-6">
            {cannotOrderReasons.map((reason, index) => (
              <p key={index} className="text-xl text-center text-accent">
                {reason}
              </p>
            ))}
          </div>
        )}
        <div
          className="py-6 px-3 rounded-lg border border-[#DFDFE2] md:py-12 md:px-[150px]"
          style={part?.frameCssProperties}
        >
          {switchFormItem(serviceFormUiState, onFieldValueChange as FieldValueChangeHandler)}
        </div>
      </EditorFrame>
    </div>
  );
};
